import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fixed z-20" }
const _hoisted_2 = { class: "flex h-screen" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layouts_auth_sidebar_content = _resolveComponent("layouts-auth-sidebar-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["transition-all duration-700 overflow-scroll hidden-scrollbar bg-white pt-12 md:pt-14 pb-16 md:pb-2", [_ctx.store.state.menu.sidebar.open ? 'w-60 sm:w-72' : 'w-0']])
        }, [
          _createVNode(_component_layouts_auth_sidebar_content)
        ], 2),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.dimmer && _ctx.store.state.menu.sidebar.open)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.dispatch('menu/switchSidebarOpen'))),
                  class: "bg-neutral-700 bg-opacity-50 w-screen"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 64))
}